import React from 'react';

import { ISanityImage } from '@rbi-ctg/menu';
import Picture from 'components/picture';

import NullPictureFallback from './null-picture-fallback';

interface IProps {
  image?: ISanityImage;
  alt?: string;
}

const Image: React.FC<IProps> = ({ image, alt = '' }) =>
  image?.asset ? <Picture image={image} alt={alt} objectFitContain /> : <NullPictureFallback />;

export default Image;
